export const FETCH_BUSINESS_REQUEST = 'FETCH_BUSINESS_REQUEST';
export const FETCH_BUSINESS_SUCCESS = 'FETCH_BUSINESS_SUCCESS';
export const FETCH_BUSINESS_FAILURE = 'FETCH_BUSINESS_FAILURE';
